module.exports = __webpack_public_path__ + "img/sticker-2-2.24cf58f9.svg";